import { ColumnTypeEnum } from '@y42/json-schema';
import { TypescriptTypeEnum } from '@y42/monaco-typescript-types';

// TODO: what with commented cases?
export const TypescriptTypeToColumnTypeConverter = function (typescriptType: TypescriptTypeEnum | string) {
  switch (typescriptType) {
    case TypescriptTypeEnum.ANY:
      return ColumnTypeEnum.Struct;
    case TypescriptTypeEnum.BOOLEAN:
      return ColumnTypeEnum.Boolean;
    case TypescriptTypeEnum.BOOLEAN_ARRAY:
    case TypescriptTypeEnum.NUMBER_ARRAY:
    case TypescriptTypeEnum.STRING_ARRAY:
      return ColumnTypeEnum.ArrayString;
    case TypescriptTypeEnum.ANY_ARRAY:
      return ColumnTypeEnum.Array;
    case TypescriptTypeEnum.NUMBER:
      return ColumnTypeEnum.Numeric;
    case TypescriptTypeEnum.STRING:
    case TypescriptTypeEnum.ENUM:
      return ColumnTypeEnum.String;
    // case TypescriptTypeEnum.NULL:
    //   return ColumnTypeEnum.null;
    case TypescriptTypeEnum.DATE:
      return ColumnTypeEnum.Date;
    case TypescriptTypeEnum.DATETIME:
      return ColumnTypeEnum.Datetime;
    case TypescriptTypeEnum.TIMESTAMP:
      return ColumnTypeEnum.Timestamp;
    default:
      // return ColumnTypeEnum.any;
      return ColumnTypeEnum.String;
  }
};
